<script setup lang="ts">
defineProps<{ orderId: number }>();
</script>

<template>
  <a v-if="orderId" :href="`/mon-compte/view-order/${orderId}`" class="link-primary font-semibold">
    #{{ orderId }}
  </a>
</template>
